import React from "react";
import { PrefillSelect } from "../../../../components/input";
import { PAYMENT_FREQUENCY_OPTIONS } from "../../../../constants/options";
import { FIELD_NAMES } from "../../../../constants/commonConstants";

export const IncomeFrequency = () => (
  <PrefillSelect
    title="How often would you like to make your repayments?"
    name={FIELD_NAMES.REPAYMENT_FREQUENCY}
    options={PAYMENT_FREQUENCY_OPTIONS}
  />
);